import { immerable } from "immer";
import type { SiteAddress } from "@/shared/business/SiteAddress.ts";
import type {
  Indicator,
  IndicatorsGroup,
} from "@/pages/human-resources/time-management/business/indicators/Indicators.ts";
import type { ScheduleTemplate } from "@/pages/human-resources/time-management/business/schedule-template/ScheduleTemplate.ts";
import type { DailyTag } from "@/pages/human-resources/time-management/business/daily-tag/DailyTag.ts";
import type { TimeManagementSitePreferences } from "@/pages/human-resources/time-management/business/preferences/TimeManagementSitePreferences.ts";
import type { SelectedIndicator } from "@/pages/human-resources/time-management/business/preferences/SelectedIndicator.ts";
import type { ShiftPeriod } from "@/pages/human-resources/time-management/business/preferences/ShiftPeriod.ts";

export class SiteScheduleReferenceData {
  [immerable] = true;

  public constructor(
    public readonly siteId: string,
    public readonly preferences: TimeManagementSitePreferences,
    public readonly siteAddress: SiteAddress,
    public readonly scheduleTemplates: ScheduleTemplate[],
    public readonly dailyTags: DailyTag[],
    public readonly availableIndicators: IndicatorsGroup[],
  ) {}

  public getShiftNumber(shift: ShiftPeriod | undefined): number | undefined {
    return shift === undefined ? undefined : (
        this.preferences.shiftPeriods.indexOf(shift) + 1
      );
  }

  public findPreferredIndicators(): Indicator[] {
    return this.preferences.selectedIndicators.map((selected) =>
      this.findIndicator(selected),
    );
  }

  private findIndicator(si: SelectedIndicator): Indicator {
    const res = this.availableIndicators
      .find((grp) => grp.uid === si.groupId)
      ?.indicators.find((indic) => indic.id === si.indicatorId);
    if (res === undefined) {
      throw new Error(
        `Failed to find indicator id ${si.indicatorId} in group with id ${si.groupId}`,
      );
    }
    return res;
  }
}
